import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Tag from '../tag';
export default function PickerTag(props) {
  return /*#__PURE__*/React.createElement(Tag, _extends({
    color: "blue"
  }, props));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/date-picker/PickerTag.js
// module id = 801
// module chunks = 0